const NavSeparator = () => {
  return <div className="w-px h-4 bg-tertiary/40 mx-0.5 xl:mx-1 2xl:mx-1.5"></div>;
};

export default NavSeparator;
